import React, { useEffect } from "react";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import "../css/flaticon.min.css";
import "../css/fontawesome-5.14.0.min.css";
import "../Main.css";
import ProgressBar from "./ProgressBar";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const MobileDevelop = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const {t}=useTranslation()
  return (
    <>
      <Helmet>
        <title>
        Top Mobile App Development Company in Chennai for Your Needs 
        </title>
        <meta
          name="description"
          content="Need a custom mobile app? Our expert mobile app development company builds user-friendly apps for iOS & Android. Get a free consultation today!"
        />
      </Helmet>
      <Header />
      <section className="page-banner-area mobile-banner pt-245 rpt-150 pb-170 rpb-100 rel z-1 bgc-lighter text-center">
        <div className="container">
          <div className="banner-inner rpt-10">
            <h1 className="page-title wow fadeInUp delay-0-2s">
              {t("mobileBannerH")}<span>{t("mobileBannerSpan")}</span>
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item">
                  <Link to="/">
                    <a>{t("mobilehome")}</a>
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#fff" }}
                >
                  {t("mobileTitle")}
                </li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="banner-shapes">
          <div
            className="circle mobilecircle wow zoomInLeft delay-0-2s"
            data-wow-duration="2s"
          />
          <img
            className="shape-one"
            src="/images/shapes/hero-shape1.png"
            alt="Shape"
            loading="lazy"
          />
          <img
            className="shape-two"
            src="/images/shapes/hero-shape2.png"
            alt="Shape"
            loading="lazy"
          />
        </div>
      </section>

      <section className="what-we-offer my-130 rel z-1">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-5 col-lg-6">
              <div className="what-we-offer-left mb-30 rmb-65 wow fadeInRight delay-0-2s">
                <div className="section-title mb-25">
                  <span
                    className="sub-title style-two mb-15"
                    style={{ color: "#b1bef3" }}
                  >
                    {t("mobilewhatH")}
                  </span>
                  <h2>{t("mobileWhatSUb")}</h2>
                </div>
                <p>
                {t("mobileWhatPara")}
                </p>
                <Link to="/contact-us">
                  <a className="theme-btn style-two mobileLearnbtn mt-15">
                    {t("learnMoreBtn")} <i className="fas fa-angle-double-right" />
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6">
              <div className="what-we-offer-right wow fadeInLeft delay-0-2s">
                <p>
                {t("mobilerightPara")}
                </p>
                <ul className="list-style-four mobileli pt-5">
                  <li>{t("mobileRightList1")}</li>
                  <li>{t("mobileRightList2")}</li>
                  <li>{t("mobileRightList3")}</li>
                  <li>{t("mobileRightList4")}</li>
                  <li>{t("mobileRightList5")}</li>
                  <li>{t("mobileRightList6")}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Area end */}
      {/* Features Area start */}
      <section className="features-area-seven pb-100 rel z-1">
        <div className="container">
          <div className="row row-cols-xl-5 row-cols-md-3 row-cols-sm-2 row-cols-1 justify-content-center">
            <div className="col">
              <div className="feature-item-seven mt-30 wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="flaticon-idea" />
                </div>
                <h5>{t("mobilestrategyH")}</h5>
                <p>
                {t("mobilestrategyPara")}
                </p>
              </div>
            </div>
            <div className="col">
              <div className="feature-item-seven color-two wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="flaticon-graphic-design" />
                </div>
                <h5>{t("mobileappDesignH")}</h5>
                <p>
                {t("mobileappDesignPara")}
                </p>
              </div>
            </div>
            <div className="col">
              <div className="feature-item-seven color-three mt-40 wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="flaticon-coding-2" />
                </div>
                <h5>{t("mobileAppdevH")}</h5>
                <p>
                {t("mobileAppdevPara")}
                </p>
              </div>
            </div>
            <div className="col">
              <div className="feature-item-seven color-four wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="flaticon-checklist" />
                </div>
                <h5>{t("mobileApptestH")}</h5>
                <p>
                {t("mobileApptestPara")}
                </p>
              </div>
            </div>
            <div className="col">
              <div className="feature-item-seven color-five mt-40 wow fadeInUp delay-0-2s">
                <div className="icon">
                  <i className="flaticon-goal" />
                </div>
                <h5>{t("mobileAppLaunchH")}</h5>
                <p>
                {t("mobileAppLaunchPara")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Features Area end */}
      {/* What We Offer Two Area start */}
      <section className="what-we-offer-two mb-130 rel z-1">
        <div className="container">
          <div className="row large-gap align-items-center">
            <div className="col-lg-6">
              <div className="what-we-offer-image rmb-65 wow fadeInRight delay-0-2s">
                <img
                  src="/assets/mobile.webp"
                  alt="What We Offer"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="what-we-offer-content wow fadeInLeft delay-0-2s">
                <div className="section-title mb-25">
                  <span
                    className="sub-title style-two mb-15"
                    style={{ color: "#b1bef3" }}
                  >
                    {t("mobilewhatH")}
                  </span>
                  <h2>
                  {t("mobileflutterH")}
                  </h2>
                </div>
                <p>
                {t("mobileflutterPara")}
                </p>
                <ul className="list-style-four mobileli pt-5 pb-30">
                  <li>{t("mobileflutterList1")}</li>
                  <li>{t("mobileflutterList2")}</li>
                  <li>{t("mobileflutterList3")}</li>
                  <li>{t("mobileflutterList4")}</li>
                </ul>
                <Link to="/contact-us">
                  <a className="theme-btn mobileLearnbtn style-two mt-15">
                    {t("learnMoreBtn")} <i className="fas fa-angle-double-right" />
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* What We Offer Two Area end */}
      {/* Responsive Design Area start */}
      <section
        className="responsive-design-area mb-130 rel z-1"
        style={{ overflow: "hidden" }}
      >
        <div className="container">
          <div className="row large-gap align-items-center">
            <div className="col-lg-6">
              <div className="responsive-design-content rmb-65 wow fadeInLeft delay-0-2s">
                <div className="section-title mb-25">
                  <span
                    className="sub-title style-two mb-15"
                    style={{ color: "#b1bef3" }}
                  >
                    {t("mobileResH")}
                  </span>
                  <h2>{t("mobileResSub")}</h2>
                </div>
                <p>
                {t("mobileResPara")}
                </p>
                <ul className="list-style-four mobileli pt-5 pb-30">
                  <li>{t("mobileReslist1")}</li>
                  <li>{t("mobileReslist2")}</li>
                  <li>{t("mobileReslist3")}</li>
                </ul>
                <Link to="/contact-us">
                  <a className="theme-btn mobileLearnbtn style-two mt-15">
                  {t("learnMoreBtn")} <i className="fas fa-angle-double-right" />
                  </a>
                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="responsive-design-image wow fadeInRight delay-0-2s">
                <img
                  src="/assets/mobiledev.png"
                  alt="Responsive Design"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Responsive Design Area end */}
      {/* CTA Two Area start */}
      <section
        className="cta-two mobile-createbg bgc-primary bgs-cover text-white py-75 rel z-1"
        style={{ backgroundImage: "url(/images/background/cta-two.png)" }}
      >
        <div className="container">
          <div className="row large-gap align-items-center">
            <div className="col-lg-5">
              <div className="cta-two-image rmb-65 wow fadeInRight delay-0-2s">
                <img src="/assets/web3.webp" alt="CTA" loading="lazy" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="cta-two-content-two wow fadeInLeft delay-0-2s">
                <div className="section-title mb-25">
                  <h2>
                  {t("mobileBoostH")}
                  </h2>
                </div>
                <p>
                {t("mobileBoostPara")}
                </p>
                <Link to="/contact-us">
                  <a className="theme-btn mobileLearnbtn2 style-two white-btn mt-15">
                  {t("mobileCreateAppBtn")}  <i className="fas fa-angle-double-right" />
                  </a>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* CTA Two Area end */}
      {/* Support & Marketing Area start */}
      <section className="support-marketing-area py-130 rel z-1">
        <div className="container">
          <div className="row large-gap justify-content-between align-items-center">
            <div className="col-lg-6">
              <div className="support-marketing-progress rmb-65 wow fadeInUp delay-0-4s">
                <div className="section-title mb-35">
                  <span
                    className="sub-title style-two mb-15"
                    style={{ color: "#b1bef3" }}
                  >
                    {t("mobileSeoH")}
                  </span>
                  <h2>{t("mobileSEOSub")}</h2>
                </div>
                <p>
                {t("mobileSeoPara")}
                </p>
                <div className="circle-counter">
                  <div className="circle-progress-item">
                    <ProgressBar value={89} color="#3180fc" />
                    <h5>{t("mobileSeoSerH")}</h5>
                  </div>
                  <div className="circle-progress-item">
                    <ProgressBar value={76} color="#f1b000" />
                    <h5>{t("mobileSeoCopyH")}</h5>
                  </div>
                  <div className="circle-progress-item">
                    <ProgressBar value={63} color="#16b4f2" />
                    <h5>{t("mobilePPCH")}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="support-marketing-list wow fadeInUp delay-0-2s">
                <ul className="list-style-one">
                  <li>
                    <div className="content">
                      <h5>{t("mobileSEOSERH")}</h5>
                      <p>
                      {t("mobileSEOSERPara")}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <h5>{t("mobileSeoCopy")}</h5>
                      <p>
                      {t("mobileSeoCopyPara")}
                      </p>
                    </div>
                  </li>
                  <li>
                    <div className="content">
                      <h5>{t("mobileSeoPPC")}</h5>
                      <p>
                      {t("mobileSeoPPCPara")}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Support & Marketing Area start */}

      <section
        className="call-to-action-area  bgc-black pt-80 pb-50"
        style={{ backgroundColor: "#b1bef3" }}
      >
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title text-white mb-25 wow fadeInUp delay-0-2s">
                <h2>{t("mobilenextappHead")}</h2>
                <p>
                {t("mobilenextappPara")}
                </p>
              </div>
            </div>
            <div className="col-lg-3 text-lg-end">
              <Link to="/contact-us">
                <a className="theme-btn mobileLearnbtn2 style-two mb-30 wow fadeInUp delay-0-4s">
                {t("mobileLanuchBtn")} <i className="fas fa-angle-double-right" />
                </a>
              </Link>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default MobileDevelop;
